import { GridOrderByModel } from '@shared/modules/grid/models/grid/grid-order-by.model';

import { Region } from '../../interfaces/regions/regions.interface';
import { Pagination } from '../../interfaces/ui/pagination.interface';
import { UserSearchRequest } from '../../models/search/search-request.model';

export namespace StoreState {
  export interface IStoreState {
    regions: Region[];
    searchRequest: UserSearchRequest;
    pagination: Pagination;
    loading: boolean;
    saveInProgress: boolean;
    allChecked?: boolean;
  }

  export const initialState: IStoreState = {
    regions: [],
    searchRequest: {
      orderBy: [new GridOrderByModel('name', true)],
      page: 0,
      pageSize: 10,
      searches: [],
      noCount: false,
      noRows: false,
      excludeActive: false,
    },
    pagination: {
      totalCount: 0,
      page: 1,
      pageCount: 1,
    },
    loading: false,
    saveInProgress: false,
  };
}
